import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { analyticsTrack } from 'app/services/auth/analytics.service';
import { KSideMenuService } from 'app/services/k-side-menu/k-side-menu.service';
import { INavigationItem } from 'app/services/navigation/navigation.types';
import { Subscription } from 'rxjs';

@Component({
  selector: 'k-side-menu',
  templateUrl: './k-side-menu.component.html',
  styleUrls: ['./k-side-menu.component.scss']
})
export class KSideMenuComponent implements OnInit, OnDestroy {

  @Input() navigationList: INavigationItem[];
  @Input() userWallet: string = '0xTESTTESTTESTufi50eA50B32f4bFcCFdD5Fb';
  // @Output() onItemClick: EventEmitter<INavigationItem> = new EventEmitter<INavigationItem>();
  @Output() onWalletClick: EventEmitter<string> = new EventEmitter<string>();
  @Output() onLogOutClick: EventEmitter<null> = new EventEmitter<null>();
  @Output() onPlayClick: EventEmitter<{ isMobile: boolean }> = new EventEmitter<{ isMobile: boolean }>();
  @Output() onNavigationItemClick: EventEmitter<{ item: INavigationItem, isMobile: boolean }> = new EventEmitter<{ item: INavigationItem, isMobile: boolean }>();
  @Output() onWOKClick: EventEmitter<{ isMobile: boolean }> = new EventEmitter<{ isMobile: boolean }>();

  maxMobileWidth: number = 600;
  maxTabletWidth: number = 960;
  isCollapsed: boolean;
  isMobile: boolean;
  _innerWidth: number = window.innerWidth;

  // menuCollapsedSubscription: Subscription

  addressText: string;

  constructor(
    private kSideMenuService: KSideMenuService
  ) { }

  ngOnInit() {
    if (this.userWallet) {
      this.addressText = this.userWallet.substr(0, 5) +
        '...' +
        this.userWallet.substr(this.userWallet.length - 4, this.userWallet.length);
    };

    this.kSideMenuService.setCollapsed(this.checkIfIsMobile());
    this.kSideMenuService.isCollapsed$.subscribe(v => {
      this.isCollapsed = v;
    })
  }

  ngOnDestroy(): void {
    // this.menuCollapsedSubscription.unsubscribe();
  }

  // itemClick(item: INavigationItem): void {
  //   this.onItemClick.emit(item);
  // }

  walletClick(): void {
    this.onWalletClick.emit(this.userWallet);
  }

  logOutClick(): void {
    analyticsTrack('clicked navigation', {
      section: 'trainerHub',
      value: 'logout',
    })
    this.onLogOutClick.emit(null);
  }

  checkIfIsMobile(): boolean {
    return window.innerWidth < this.maxMobileWidth ? true : false;
  }

  actionMenu(action: string): void {
    this.kSideMenuService.setCollapsed(action === 'close' ? true : false);
  }
  playClick() {
    this.onPlayClick.emit({ isMobile: this.checkIfIsMobile() });
    analyticsTrack('clicked navigation', {
      section: 'trainerHub',
      value: 'play',
    });
  }

  clickWOK() {
    this.onWOKClick.emit({ isMobile: this.checkIfIsMobile() });
    analyticsTrack('clicked navigation', {
      section: 'trainerHub',
      value: 'wok',
    });
  }

  clickLeaderboard() {
    analyticsTrack('clicked navigation', {
      section: 'trainerHub',
      value: 'leaderboard',
    });
  }

  navigationClick(pageItem: INavigationItem) {
    this.onNavigationItemClick.emit({ item: pageItem, isMobile: this.checkIfIsMobile() });
    analyticsTrack('clicked navigation', {
      section: 'trainerHub',
      value: pageItem.target.replace('/', ''),
    });
  }

  //host listener to understand when windows is resized
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    let reduce: boolean = window.innerWidth < this._innerWidth;
    this._innerWidth = window.innerWidth;
    if (reduce) this.kSideMenuService.setCollapsed(this.checkIfIsMobile() ? true : this.isCollapsed);
    else this.kSideMenuService.setCollapsed(this.checkIfIsMobile() ? this.isCollapsed : false);
  }

}
